import { List, Datagrid, TextField, ListProps, DateField } from 'react-admin'
import { useTranslate } from 'ra-core'
import datagridStyles from '../../layout/styles/datagridStyles'
import SchoolTagListFilters from './SchoolTagListFilters'
import BulkActionButtons from 'components/common/BulkActionButtons'
import { CustomDatagridBody } from 'components/common/CustomDatagridBody'
import { DEFAULT_PER_PAGE } from 'globals'

const SchoolTagList = (props: ListProps) => {
    const datagridClasses = datagridStyles()
    const translate = useTranslate()

    return (
        <List
            {...props}
            sort={{ field: 'tag', order: 'DESC' }}
            perPage={DEFAULT_PER_PAGE}
            filters={SchoolTagListFilters}
            bulkActionButtons={<BulkActionButtons />}
        >
            <Datagrid body={<CustomDatagridBody />} classes={datagridClasses} rowClick="edit">
                <TextField source="tag" label={translate('manager.resources.tag.name')} />
                <DateField
                    label={translate('manager.resources.general.last_updated')}
                    source="updated_at"
                    showTime
                />
            </Datagrid>
        </List>
    )
}
export default SchoolTagList
